import React from 'react';

const ContactUs = () => {
    return (
        <div>
            <div className="hero min-h-screen bg-white">
  <div className="hero-content flex-col lg:flex-row">
    <div className="text-center lg:text-left">
      <img className='w-full' src="https://i.ibb.co/nn00r6y/contact-us-concept-illustration-114360-3147.jpg" alt="" />

    </div>
    <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
      <div className="card-body bg-slate-400 ">
        <div className="form-control ">
          <label className="label ">
            <span className="label-text font-bold text-white">Email</span>
          </label>
          <input type="text" placeholder="email" className="input input-bordered" />
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text font-bold text-white">Name</span>
          </label>
          <input type="text" placeholder="Name" className="input input-bordered" />
          <label className="label">
            <span className="label-text font-bold text-white">Message</span>
          </label>
          <textarea type="text" placeholder="Enter your message" className="input input-bordered" />
          <label className="label">
            <p className="label-text-alt link link-hover">We will contact you within 24 hours</p>
          </label>
        </div>
        <div className="form-control mt-6">
          <button className="btn btn-primary">Login</button>
        </div>
      </div>
    </div>
  </div>
</div>
        </div>
    );
};

export default ContactUs;